import { IPaymentCard } from '../../types/global/generic.types';
import { ISaleObject } from '../../types/global/helper';

export const types = {
    OPEN_CHECKOUT: 'OPEN_CHECKOUT',
    CLOSE_CHECKOUT: 'CLOSE_CHECKOUT',
    SET_CHECKOUT_ITEMS: 'SET_CHECKOUT_ITEMS',
    ADD_CHECKOUT_ITEM: 'ADD_CHECKOUT_ITEM',
    REMOVE_CHECKOUT_ITEM: 'REMOVE_CHECKOUT_ITEM',
    UPDATE_CHECKOUT_ITEM_QUANTITY: 'UPDATE_CHECKOUT_ITEM_QUANTITY',
    APPLY_DISCOUNT: 'APPLY_DISCOUNT',
    VERIFY_DISCOUNT: 'VERIFY_DISCOUNT',
    REMOVE_DISCOUNT: 'REMOVE_DISCOUNT',
    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
    PROCESS_PAYMENT: 'PROCESS_PAYMENT',
    PROCESS_PAYMENT_SUCCESS: 'PROCESS_PAYMENT_SUCCESS',
    PROCESS_PAYMENT_FAIL: 'PROCESS_PAYMENT_FAIL',
    RESET_CHECKOUT: 'RESET_CHECKOUT',
    INITIATE_REFUND: 'INITIATE_REFUND',
    INITIATE_REFUND_SUCCESS: 'INITIATE_REFUND_SUCCESS',
    INITIATE_REFUND_FAIL: 'INITIATE_REFUND_FAIL',
};

export interface ICheckoutItem {
    id: string;
    title: string;
    description?: string;
    price: number;
    original_price: number;
    breakdown?: Record<string, any>;
    currency: string;
    quantity: number;
    image?: string;
    details?: Array<{
        label: string;
        value: string | number;
    }>;
}

export interface IDiscount {
    code: string;
    type: 'percentage' | 'fixed';
    value: number;
    message?: string;
}

export interface ICurrencyInfo {
    transaction_currency: string;
    original_currency?: string;
    rate?: number;
}

export interface ICheckoutInitialState {
    isOpen: boolean;
    items: ICheckoutItem[];
    discount?: IDiscount;
    selectedPaymentMethod?: IPaymentCard | 'new_card';
    processing: boolean;
    error?: string;
    success?: boolean;
    currency: string;
    /** We prefer this for stripe processing */
    originalCurrency: string;
    currencyInfo?: ICurrencyInfo;
    saleObject?: ISaleObject;
    refundingTickets: Record<string, 'refund-in-progress' | 'refunded'>;
    submissionSalesObject?: ISaleObject;
}

export interface IOpenCheckout {
    items: ICheckoutItem[];
    currency?: string;
    currencyInfo?: {
        transaction_currency: string;
        processing_currency: string;
        original_currency?: string;
        rate?: number;
    };
    saleObject: ISaleObject;
}

export interface IAddCheckoutItem {
    item: ICheckoutItem;
}

export interface IRemoveCheckoutItem {
    itemId: string;
}

export interface IUpdateCheckoutItemQuantity {
    itemId: string;
    quantity: number;
}

export interface IApplyDiscount {
    code: string;
    type: 'percentage' | 'fixed';
    value: number;
}

export interface IVerifyDiscount {
    id: string;
    discount_code: string;
    type: 'event' | 'contest' | 'audition';
}

export interface ISetPaymentMethod {
    paymentMethod: IPaymentCard | 'new_card';
}

export interface IProcessPayment {
    items: ICheckoutItem[];
    total: number;
    paymentMethod: IPaymentCard | { token: string };
    discount?: IDiscount;
    currency?: string;
    metadata?: Record<string, any>;
    saleObject: ISaleObject;
    category?: string;
}

export interface IPaidTicket {
    id: string;
    name: string;
    price: number;
    quantity: number;
    description: string;
    currency: string;
    original_currency: string;
    transaction_currency: string;
    original_price: number;
    exchange_rate: number;
}

export interface IFreeTicket {
    id: string;
    name: string;
    quantity: number;
    features: string[];
    description: string;
    original_price: 0;
    price: 0;
}
export interface TicketSummary {
    paid: IPaidTicket[];
    free: IFreeTicket[];
    totalPaidAmount: number;
    totalAmountToPayInOriginalCurrency: number;
    currency: string;
    originalCurrency: string;
}

export interface IInitiateRefund {
    saleId: string;
    reason: string;
    details: string;
}

export interface IRefundResponse {
    refund: any;
    ticket: {
        _id: string;
        state: 'refund-in-progress' | 'refunded';
    };
}
